import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/useAuth";
import { decodeJwt } from "../utils/decodeJwt";

export function PaidRoute({ children }) {
  const { token, isPaid } = useAuth();

  const exp = decodeJwt(token)?.exp;
  if (!token || (exp && exp * 1000 <= Date.now())) {
    return <Navigate to="/" replace />;
  }

  if (!isPaid) {
    return <Navigate to="/buy" replace />;
  }

  return children;
}
